/* eslint-disable */
import { useContext, useEffect, useState } from "react";
import { differenceInDays } from "date-fns";

import { useNavigate } from "react-router-dom";

import { Modal } from "../../common/Modal";
import { RootState, useAppSelector } from "../../store/store";
import { LocalizationContext } from "../../App";
import { ChevronRight, Insurance, ShieldCheck } from "../../common/icons";
import { useGetCustomerDetailsQuery } from "../../store/userSlice";
import { useGetPoliciesQuery } from "../../store/policiesSlice";
import { PolicyStatus } from "../../models/enum/PolicyStatus";
import { Policy } from "../../models/policy";
import { ProductContext } from "../../context/ProductContext";
import { environment } from "../../environments/environment";

export const HomePage = () => {
  const navigate = useNavigate();
  const [recentlyAmended, setRecentlyAmended] = useState<number[]>([]);
  const isLoggedIn = useAppSelector((state) => state.auth.isUserLogged);
  const l10n = useContext(LocalizationContext);
  const { productIdToTypeKeyDict } = useContext(ProductContext);
  const { bankName = "" } = useAppSelector((state: RootState) => state.app);
  const [showFAQ, setFAQPage] = useState<string>();
  const { data: profile, isLoading: isProfileLoading } =
    useGetCustomerDetailsQuery(undefined, {
      refetchOnMountOrArgChange: true,
      skip: !isLoggedIn,
    });
  const { currentData: policies, isLoading: arePoliciesLoading } =
    useGetPoliciesQuery(undefined, {
      skip: !isLoggedIn,
      refetchOnMountOrArgChange: true,
    });
  const [offers, setOffers] = useState<Policy[]>([]);
  // const [waitingOffers, setWaitingOffers] = useState<Policy[]>([]);
  const [activePolicies, setActivePolicies] = useState<Policy[]>([]);
  const [nothingToShow, setNothingToShow] = useState<boolean>(false);

  useEffect(() => {
    if (localStorage["policiesAmended"]) {
      var data = JSON.parse(localStorage["policiesAmended"]) as {
        time: Date;
        policies: number[];
      };
      if (data) setRecentlyAmended(data.policies);
    }
  }, []);

  useEffect(() => {
    if (policies?.length) {
      setOffers(
        policies.filter(
          (p) =>
            p.statusId === PolicyStatus.Offer &&
            ![2, 23].includes(p.subStatusId) &&
            !recentlyAmended.includes(p.id) &&
            differenceInDays(p.validFromDate, new Date()) <=
              environment.settings.numberOfInceptionDays
        )
      );
      //setWaitingOffers(
      //  policies.filter(
      //    (p) =>
      //      p.statusId === PolicyStatus.Offer &&
      //      ([2, 23].includes(p.subStatusId) ||
      //        recentlyAmended.includes(p.id) ||
      //        differenceInDays(p.validFromDate, new Date()) > environment.settings.numberOfInceptionDays)
      //  )
      //);
      setActivePolicies(
        policies.filter(
          (p) =>
            p.statusId === PolicyStatus.Policy ||
            (p.statusId === PolicyStatus.Offer &&
              ([2, 23].includes(p.subStatusId) ||
                recentlyAmended.includes(p.id) ||
                differenceInDays(p.validFromDate, new Date()) >
                  environment.settings.numberOfInceptionDays))
        )
      );
    }
  }, [policies]);

  useEffect(() => {
    if (!arePoliciesLoading) {
      setNothingToShow(
        (!offers || offers.length === 0) &&
          (!activePolicies || activePolicies.length === 0)
      );
    }
  }, [arePoliciesLoading, activePolicies, offers]);

  useEffect(() => {
    if (!isProfileLoading && !profile?.acquisitionStatus) {
      navigate("/activate-account", {
        state: {
          disableNavigation: true,
        },
      });
    }
  }, [isProfileLoading, profile, navigate]);

  if (isProfileLoading || arePoliciesLoading)
    return (
      <div className="loading-screen flex flex-col justify-center items-center">
        <div className="text-body text-xl">{l10n.common.loading}</div>
      </div>
    );

  const selectFAQ = (product?: string) => {
    setFAQPage(product);
  };

  return (
    <>
      <h2>
        <span className="font-normal">{l10n.title.welcome}</span>
        {profile?.fullName && (
          <>
            <span className="font-normal">,{" "}</span>
            <span className="font-semibold">{profile?.firstName}</span>
          </>
        )}
      </h2>

      {offers && offers.length > 0 && (
        <>
          {offers.map((offer) => (
            <div
              key={
                l10n.products[productIdToTypeKeyDict[offer.productTypeId]].name
              }
              className="card"
            >
              <div className="card-body">
                <span className="text-card text-lg font-semibold">
                  {
                    l10n.products[productIdToTypeKeyDict[offer.productTypeId]]
                      .name
                  }
                </span>
                {/* <a
                  href={l10n.faq[offer.summary].link}
                  className="flex items-center text-card text-sm mb-2"
                  target="_blank"
                >
                  {l10n.btn.learnMore}
                  <ChevronRight className="w-3 h-3 shrink-0 stroke-card stroke-[3px] ml-2" />
                </a> */}
                <div className="flex justify-end">
                  <div className="flex items-end">
                    <div className="offer-item-carrier">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <button
            onClick={() => navigate("/products")}
            className="btn-card-action btn-primary"
          >
            {l10n.btn.complete}
          </button>
        </>
      )}

      {/* {waitingOffers && waitingOffers.length > 0 && (
        <>
         <h2 className="card-title">{l10n.title.yourOffersAccepted}</h2>
          {waitingOffers.map((offer) => (
            <div
              key={l10n.products[productIdToTypeKeyDict[offer.productTypeId]].name}
              className="offer-item"
            >
              <h4 className="font-semibold !mb-0">
                {l10n.products[productIdToTypeKeyDict[offer.productTypeId]].name}
              </h4>
              <a
                href={l10n.faq[offer.summary].link}
                className="flex items-center text-sm mb-2"
                target="_blank"
              >
                {l10n.btn.learnMore}
                <ChevronRight className="w-3 h-3 shrink-0 stroke-card stroke-[3px] ml-2" />
              </a>
              <div className="flex justify-end">
                <div className="flex items-end">
                  <div className="offer-item-carrier">&nbsp;</div>
                </div>
              </div>
            </div>
          ))}
        </>
      )} */}

      {activePolicies && activePolicies.length > 0 && (
        <>
          <h3>
            <span className="w-auto inline-flex items-center" onClick={() => navigate("insurance")}>
              {l10n.title.yourActiveProducts}
              <ChevronRight className="ml-1 w-5 h-5" />
            </span>
          </h3>
          {activePolicies?.map((offer) => (
            <div
              className="card"
              key={
                l10n.products[productIdToTypeKeyDict[offer.productTypeId]].name
              }
            >
              <div className="card-body">
                <span className="text-card text-lg font-semibold">
                  {
                    l10n.products[productIdToTypeKeyDict[offer.productTypeId]]
                      .name
                  }
                </span>
                {/* <a
                  href={
                    l10n.faq[productIdToTypeKeyDict[offer.productTypeId]].link
                  }
                  className="flex items-center text-card text-sm mb-2"
                  target="_blank"
                >
                  {l10n.btn.learnMore}
                  <ChevronRight className="w-3 h-3 shrink-0 stroke-card stroke-[3px] ml-2" />
                </a> */}
                <div className="flex justify-end">
                  <div className="flex items-end">
                    <div className="offer-item-carrier">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      )}

      {nothingToShow && (
        <div className="no-data-screen flex flex-col justify-center items-center text-center text-body px-4">
          <Insurance className="w-32 h-32 stroke-1 stroke-no-data" />
          <div className="mt-4 text-body">{l10n.noData.activePolicies}</div>
        </div>
      )}

      {/*By DDX-260 modal has been excluded from page. By requirement now only show fact-sheet. We leave modal for possible change of requirement*/}
      {showFAQ && (
        <Modal backgroundTransparency={80} onClose={() => selectFAQ(undefined)}>
          <div className="modal-body">
            <div className="w-12 h-12 p-2 bg-primary rounded-3xl justify-center items-center inline-flex">
              <ShieldCheck className={"w-8 h-8 stroke-primary-inverted"} />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex">
              <div className="w-72 text-center text-xl font-bold leading-7">
                {l10n.faq[showFAQ].title}
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-2 flex">
              <div className="w-72 text-center text-xl font-bold leading-7">
                <a
                  href={l10n.faq[showFAQ].link}
                  className="underline underline-offset-1"
                  target="_blank"
                >
                  {l10n.faq[showFAQ].docName}
                </a>
              </div>
            </div>

            {l10n.faq[showFAQ].faqs.map((qa, index) => (
              <div className="w-100 inline-flex flex-col" key={index}>
                <b>{qa.q}</b>
                <div
                  className="flex-1 text-base"
                  dangerouslySetInnerHTML={{
                    __html: qa.a.replace("{bankName}", bankName),
                  }}
                />
              </div>
            ))}
          </div>
        </Modal>
      )}
    </>
  );
};
